import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    type: Yup.string()
      .trim()
      .required("This field is required"),
    rd: Yup.object()
      .nullable()
      .required("This field is required"),

    service: Yup.mixed()
      .nullable()
      .required("This field is required"),
    referral_note: Yup.string()
      .trim()
      .required("This field is required")
  }),
  mapPropsToValues: props => ({
    type: "",
    rd: null,
    service: null,
    referral_note: "",
    internal_rd: null
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
